import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { headerSearch, tabs, toogleButton, unoTheme } from '../../../assets/styles/unoTheme';

import { MyTab, MyTabs } from "../../utils/MyTabs";
import { getMonthName, getMonthsUntilPortfolioInit, getQuartersByMonthsArray, getSemestersByMonthsArray, getStartDateAndEndDateByMonthYear } from "../../utils/utils";
import AccountsScreen from './AccountsScreen';
import AprsScreen from './AprsScreen';
import AssetsScreen from './AssetsScreen';
import CostsScreen from './CostsScreen';


//UnoButton
import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import MyToggleSegregationButton from "../../utils/MyToggleSegregationButton";
import UnoButton from '../../utils/UnoButton';
import MySelect from '../../utils/MySelect';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import CodeIcon from '@material-ui/icons/Code';
import SortIcon from '@material-ui/icons/Sort';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { BalancesValidationsAPI } from "../../../API/balances_validations";
import { ClientAPI } from '../../../API/client';
import { FundLocalQuotasAPI } from '../../../API/fund_local_quotas';
import { loadClientDiaryByRange } from "../../../controllers/ClientController";
import { checkUserIsRole, roles } from "../../utils/user";
import { Badge, Tooltip } from '@material-ui/core';
import { TransactionAPI } from '../../../API/transaction';

import PortfolioAnalysisModal from '../../modals/PortfolioAnalysisModal';
import {
    findEqualBalancePairs,
    findInvalidDiaryCountMonths,
    findMissingDiaryMonths,
    groupDuplicatesByKey,
} from '../../utils/portfolioAnalysisUtils';

import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        fontWeight: 'bold'
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    green: {
        color: unoTheme.greenMoney
    },
    selectableRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            //padding: '3px 12px 3px 8px !important',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

        '&:hover': {
            color: 'white',
            background: unoTheme.mainColor,
            '& > *': {
                color: 'white',
                '& .MuiSvgIcon-root': {
                    fill: 'white',
                }

            }
        }

    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
    },

    toogleButton: toogleButton,

    aprBadge: {
        '& .MuiBadge-badge': {
            marginRight: "-10px !important",
            backgroundColor: "#f1c40f !important"
        }
    }
}));

const specificClientsIdsToRemoveApr = [455]; //Camaçari

export default function PortfolioScreen() {

    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)
    const innerLoad = useSelector(state => state.innerLoad)

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [tabValue, setTabValue] = React.useState(0);

    const ACCOUNT_TAB_INDEX = 1;

    const [countBlankAprs, setCountBlankAprs] = useState();

    const [flagDoExcelPortfolio, setFlagDoExcelPortfolio] = React.useState(false);
    const [flagDoNewAccount, setFlagDoNewAccount] = React.useState(false);
    const [flagDoReportBatchAprs, setFlagDoReportBatchAprs] = React.useState(0);
    const [flagDoExcelTransactions, setFlagDoExcelTransactions] = React.useState(false);
    const [flagDoReorganizeAprs, setFlagDoReorganizeAprs] = React.useState(false);

    // Análise de inconsistências da carteira
    const [portfolioAnalysis, setPortfolioAnalysis] = useState(null);
    const [showPortfolioAnalysisModal, setShowPortfolioAnalysisModal] = useState(false);

    // Filtros da aba Custos (state no pai para exibir no header)
    const [costsYear, setCostsYear] = useState(0); // index no array costsYearOptions
    const [costsPeriodType, setCostsPeriodType] = useState('trimestral');
    const [costsSubPeriod, setCostsSubPeriod] = useState(0); // index no array de opções
    const [costsYearOptions, setCostsYearOptions] = useState([]);
    const [costsPortfolioData, setCostsPortfolioData] = useState(null); // { years, months }
    const [costsQuarterOptions, setCostsQuarterOptions] = useState([]);
    const [costsSemesterOptions, setCostsSemesterOptions] = useState([]);
    const [costsMonthOptions, setCostsMonthOptions] = useState([]);
    const [costsReportData, setCostsReportData] = useState(null);

    //Enquadramento da carteira na Resolução 5.272, vindo da AssetsScreen.
    //Nulo nas demais resoluções e quando o usuário não tem acesso ao compliance,
    //e é o que decide se o botão de status aparece no header
    const [complianceStatus, setComplianceStatus] = useState(null);

    //Opções de mês/trimestre/semestre do ano selecionado no filtro de Custos
    function setCostsOptionsForMonths(monthsForYear) {
        setCostsMonthOptions(monthsForYear.map(month => ({ month, name: getMonthName(month) })));
        setCostsQuarterOptions(getQuartersByMonthsArray(monthsForYear));
        setCostsSemesterOptions(getSemestersByMonthsArray(monthsForYear));
    }

    //No mensal o padrão é o mês mais recente do ano; trimestre e semestre começam pelo primeiro
    function getDefaultCostsSubPeriod(periodType, monthsCount) {
        return periodType === 'mensal' && monthsCount > 0 ? monthsCount - 1 : 0;
    }

    // Calcula opções de anos/meses/trimestres/semestres baseado nos dados reais do portfolio.
    // Depende só do que define os períodos da carteira: o setClient dos selects globais de
    // mês/ano cria um clientOn novo e, com [clientOn], o filtro de Custos voltava ao padrão.
    const costsClientId = clientOn?.client?.id;
    const costsPortfolioInit = clientOn?.client?.portfolio_init;
    const costsPortfolioClosed = clientOn?.client?.portfolio_closed;
    useEffect(() => {
        if (clientOn && clientOn.client) {
            const portfolioData = getMonthsUntilPortfolioInit(
                clientOn.client.portfolio_init,
                clientOn.client.portfolio_closed
            );
            if (portfolioData && portfolioData.years && portfolioData.years.length) {
                setCostsPortfolioData(portfolioData);
                setCostsYearOptions(portfolioData.years);

                // Seleciona o último ano por padrão
                const lastYearIndex = portfolioData.years.length - 1;
                setCostsYear(lastYearIndex);

                // Calcula meses, trimestres e semestres para o último ano
                const monthsForYear = portfolioData.months[portfolioData.years[lastYearIndex]] || [];
                setCostsOptionsForMonths(monthsForYear);
                setCostsSubPeriod(getDefaultCostsSubPeriod(costsPeriodType, monthsForYear.length));
            }
        }
    }, [costsClientId, costsPortfolioInit, costsPortfolioClosed]);

    function handleCostsPeriodType(event, newType) {
        if (newType !== null) {
            setCostsPeriodType(newType);
            setCostsSubPeriod(getDefaultCostsSubPeriod(newType, costsMonthOptions.length));
        }
    }

    function handleCostsYear(value) {
        const idx = parseInt(value);
        setCostsYear(idx);

        const monthsForYear = (costsPortfolioData && costsPortfolioData.months
            && costsPortfolioData.months[costsYearOptions[idx]]) || [];
        setCostsOptionsForMonths(monthsForYear);
        setCostsSubPeriod(getDefaultCostsSubPeriod(costsPeriodType, monthsForYear.length));
    }

    // Valores reais derivados dos índices (para passar ao CostsScreen)
    const costsYearValue = costsYearOptions.length > 0 ? costsYearOptions[costsYear] : null;
    const costsSubPeriodValue = (() => {
        if (costsPeriodType === 'mensal' && costsMonthOptions[costsSubPeriod]) {
            return costsMonthOptions[costsSubPeriod].month;
        }
        if (costsPeriodType === 'trimestral' && costsQuarterOptions[costsSubPeriod]) {
            // Mapeia startMonth para número do trimestre: 1->1, 4->2, 7->3, 10->4
            return Math.ceil(costsQuarterOptions[costsSubPeriod].startMonth / 3);
        }
        if (costsPeriodType === 'semestral' && costsSemesterOptions[costsSubPeriod]) {
            return costsSemesterOptions[costsSubPeriod].startMonth <= 6 ? 1 : 2;
        }
        return 1;
    })();

    function resetFlag() {

        setFlagDoReportBatchAprs(false);
        setFlagDoExcelTransactions(false);
        setFlagDoExcelPortfolio(false);
        setFlagDoNewAccount(false);
        setFlagDoReorganizeAprs(false);

    }

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push('/portfolio/assets')
        } else if (newValue == 1) {
            history.push('/portfolio/accounts')
        } else if (newValue == 2) {
            history.push('/portfolio/aprs')
        } else if (newValue == 3) {
            history.push('/portfolio/costs')
        }

    };

    const [formats, setFormats] = React.useState(() => null);

    const handleFormat = (event, newFormats) => {

        console.log("NEW FORMAT: ", newFormats)

        switch (newFormats) {

            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
            case 3:
                break;

        }

        setFormats(newFormats);
    };

    //As validações de saldo retornam apenas os ids do ativo/conta; os mapas abaixo
    //fornecem os rótulos amigáveis (nome do fundo, CNPJ, conta e instituição)
    function buildAssetLabelsMap(responses) {

        const map = {};

        responses.forEach(response => {

            if (!response?.body?.rows?.length) return;

            response.body.rows.forEach(row => {
                if (row.asset_id === null || row.asset_id === undefined) return;
                if (map[row.asset_id]) return;
                map[row.asset_id] = {
                    fund_name: row.fund_name,
                    cnpj: row.cnpj,
                    number_account: row.asset_number_account,
                };
            });
        });

        return map;
    }

    function buildAccountLabelsMap(response) {

        const map = {};

        if (!response?.body?.rows?.length) return map;

        response.body.rows.forEach(row => {
            if (row.account_id === null || row.account_id === undefined) return;
            if (map[row.account_id]) return;
            map[row.account_id] = {
                number_account: row.number_account,
                agency: row.agency,
                instituition_account: row.instituition_account,
            };
        });

        return map;
    }

    async function doPortfolioAnalyze() {

        const client = clientOn?.client;
        if (!client) return;

        const month = client.selectedPortfolioMonth;
        const year = client.selectedPortfolioYear;

        //Saldos duplicados são verificados também no mês seguinte
        let nextMonth = month + 1;
        let nextYear = year;
        if (nextMonth === 13) {
            nextMonth = 1;
            nextYear++;
        }

        //A query de ativos da carteira joina fund_local_quotas no mês selecionado E no anterior,
        //então cotas locais duplicadas em qualquer um dos dois duplicam o ativo
        let prevMonth = month - 1;
        let prevYear = year;
        if (prevMonth === 0) {
            prevMonth = 12;
            prevYear--;
        }

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: "Analisando carteira..."
        }))

        //Em dezembro o mês seguinte cai no ano seguinte, então os rótulos vêm dos dois anos
        const yearsToLabel = nextYear !== year ? [year, nextYear] : [year];

        try {

            const [
                diarys,
                currentBalances,
                currentBalancesAccounts,
                nextBalances,
                assetsInfos,
                accountsInfos,
                duplicatedLocalQuotas,
            ] = await Promise.all([
                loadClientDiaryByRange(client.id, month, year, 'ano'),
                BalancesValidationsAPI.getBalancesByMonthAndYear(client.id, month, year),
                BalancesValidationsAPI.getBalancesAccountsByMonthAndYear(client.id, month, year),
                BalancesValidationsAPI.getBalancesByMonthAndYear(client.id, nextMonth, nextYear),
                //Apenas para os rótulos. Atenção: essas APIs recebem (ano, clientId) nessa ordem
                Promise.all(yearsToLabel.map(y =>
                    ClientAPI.getClientInvestmentsBalancesValidationsByYear(y, client.id))),
                ClientAPI.getClientAccountsBalancesValidationsByYear(year, client.id),
                FundLocalQuotasAPI.getDuplicatedLocalQuotasByClient(client.id, month, year),
            ]);

            const currentBalancesRows = currentBalances?.body?.rows ?? [];

            setPortfolioAnalysis({
                missingDiaryMonths: findMissingDiaryMonths(diarys?.arrayRents, month, year,
                    client.portfolio_init, client.portfolio_closed),
                invalidDiaryCountMonths: findInvalidDiaryCountMonths(diarys?.arrayRents),
                duplicatedCurrentBalances: groupDuplicatesByKey(currentBalancesRows, 'asset_id'),
                duplicatedNextBalances: groupDuplicatesByKey(nextBalances?.body?.rows ?? [], 'asset_id'),
                duplicatedAccountBalances: groupDuplicatesByKey(currentBalancesAccounts?.body?.rows ?? [], 'account_id'),
                equalBalancePairs: findEqualBalancePairs(currentBalancesRows),
                assetLabelsMap: buildAssetLabelsMap(assetsInfos),
                accountLabelsMap: buildAccountLabelsMap(accountsInfos),
                duplicatedLocalQuotas: duplicatedLocalQuotas?.body?.rows ?? [],
                nextPeriod: { month: nextMonth, year: nextYear },
                previousPeriod: { month: prevMonth, year: prevYear },
            });

            setShowPortfolioAnalysisModal(true);

        } catch (error) {

            console.error("Erro na análise da carteira: ", error);
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Não foi possível concluir a análise da carteira.'
            }))

        } finally {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
        }
    }

    const getCountBlankAprs = useCallback(async (clientId, month, year) => {

        const { startDate, endDate } = getStartDateAndEndDateByMonthYear(month, year);
        const response = await TransactionAPI.getBlankTransactionsByClientIdAndDateRange(clientId, startDate, endDate);
        if (response.success) {
            setCountBlankAprs(response.body.rows.filter(el => !el.is_transfer && !el.is_split).length);
        } else {
            setCountBlankAprs(undefined);
        }
    }, [])

    //Caso em que alterou-se o cliente
    if (clientOn && clientOn.client
        && (!clientOnScreen || clientOn.client.id != clientOnScreen.id)) {

        setClientOnScreen(_.cloneDeep(clientOn.client));
        getCountBlankAprs(clientOn.client.id,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear)

        //Caso em que alterou-se o mês ou o ano no controller no dashboard
    } else if (clientOn && clientOn.client && clientOnScreen
        && clientOn.client.id == clientOnScreen.id
        && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear
        && clientOn.client.portfolio_closed != clientOnScreen.portfolio_closed) {

        setClientOnScreen(_.cloneDeep(clientOn.client));
        getCountBlankAprs(clientOn.client.id,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear)

        //Caso em que alterou-se o mês ou o ano
    } else if (clientOn && clientOn.client && clientOnScreen
        && clientOn.client.id == clientOnScreen.id
        && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear
        && (
            clientOn.client.selectedPortfolioMonth != clientOnScreen.selectedPortfolioMonth
            ||
            clientOn.client.selectedPortfolioYear != clientOnScreen.selectedPortfolioYear
        )
    ) {
        getCountBlankAprs(clientOn.client.id,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear)

    }

    useEffect(() => {

        console.log("LOCATION: ", location)
        if (location) {
            if (location.pathname.startsWith('/portfolio/costs') && tabValue != 3) {
                setTabValue(3);
            } else if (location.pathname.startsWith('/portfolio/aprs') && tabValue != 2) {
                setTabValue(2);
            } else if (location.pathname.startsWith('/portfolio/accounts') && tabValue != 1) {
                setTabValue(1);
            } else if (location.pathname.startsWith('/portfolio/assets') && tabValue != 0) {
                setTabValue(0);
            }
        }

    }, [location]);

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={[classes.tabs, classes.shortWidthTab].join(' ')}
                    style={tabValue == 3 ? { width: 'auto' } : {}}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}
                        aria-label="disabled tabs example">

                        <MyTab label="Ativos" />
                        <MyTab label="Contas" />

                        {
                            (!checkUserIsRole(currentUser, [roles.viewer])
                                ||
                                (checkUserIsRole(currentUser, [roles.viewer]) && !specificClientsIdsToRemoveApr.includes(clientOn?.client?.id)))
                            &&

                            // <MyTab label="APRs" />
                            <MyTab label={
                                countBlankAprs ?
                                    <Badge
                                        className={classes.aprBadge}
                                        //variant='dot'
                                        badgeContent={countBlankAprs}
                                        color="error">
                                        APRs
                                    </Badge>
                                    :
                                    "APRs"
                            } />


                        }

                        <MyTab label="Custos" />

                    </MyTabs>

                    {/* <div className={classes.bottomTabs}></div> */}
                </div>

                <div className={classes.rightHeader}>

                    {tabValue != 3 && (
                        <>
                            {
                                //Exibido apenas para SUPER ADMIN
                                checkUserIsRole(currentUser, [roles.superadmin, roles.admin]) ?
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>

                                        {tabValue == 0 && (
                                            <UnoButton
                                                isIconButton
                                                size='small'
                                                type='warning'
                                                myIcon={<CodeIcon />}
                                                onClick={() => doPortfolioAnalyze()}
                                            />
                                        )}

                                        {tabValue == 2 && (
                                            <UnoButton
                                                isIconButton
                                                size='small'
                                                type='warning'
                                                myIcon={<SortIcon />}
                                                onClick={() => setFlagDoReorganizeAprs(true)}
                                                style={{ marginLeft: '8px' }}
                                            />
                                        )}

                                    </div> : null
                            }

                            {
                                //Exibido apenas no menu de APRS
                                tabValue == 0 ?
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>

                                        {
                                            //Status de enquadramento na 5.272. O botão abre o painel em qualquer
                                            //dos três estados: desenquadrado, na aba dos desenquadramentos;
                                            //enquadrado, na das regras contempladas — que antes não tinha como
                                            //ser vista, porque o verde não levava a lugar nenhum.
                                            //O gate de role é o da AssetsScreen: sem acesso, não chega status
                                            complianceStatus ?
                                                <Tooltip
                                                    arrow
                                                    placement='top'
                                                    title={complianceStatus.isOut ?
                                                        `${complianceStatus.totalViolations} ${complianceStatus.totalViolations == 1 ? 'desenquadramento' : 'desenquadramentos'} na Resolução ${complianceStatus.resolutionName || '5.272'} — clique para ver o detalhamento`
                                                        : (complianceStatus.notEvaluatedBalance > 0 ?
                                                            `Carteira enquadrada na Resolução ${complianceStatus.resolutionName || '5.272'}, mas há regras não verificadas por falta de cadastro — clique para ver quais`
                                                            : `Carteira enquadrada na Resolução ${complianceStatus.resolutionName || '5.272'}`
                                                            + `${complianceStatus.overview ?
                                                                ' — ' + complianceStatus.overview.counts.compliant
                                                                + (complianceStatus.overview.counts.compliant == 1 ?
                                                                    ' regra contemplada' : ' regras contempladas')
                                                                : ''}`
                                                            + ' — clique para ver o detalhamento')}>
                                                    <span>
                                                        <UnoButton
                                                            size={'small'}
                                                            removeDefaultLeftMargin
                                                            style={{ marginRight: '16px' }}
                                                            isIconButton
                                                            type={complianceStatus.isOut ? 'error'
                                                                : (complianceStatus.notEvaluatedBalance > 0 ? 'warningClean' : 'successClean')}
                                                            myIcon={complianceStatus.isOut || complianceStatus.notEvaluatedBalance > 0 ?
                                                                <WarningIcon /> : <CheckCircleIcon />}
                                                            onClick={() =>
                                                                dispatch(allActions.rightContentActions.setRightContent({
                                                                    path: 'articlesRulesCompliance',
                                                                    data: {
                                                                        byCode: complianceStatus.byCode,
                                                                        resolutionName: complianceStatus.resolutionName,
                                                                        totalViolations: complianceStatus.totalViolations,
                                                                        notEvaluated: complianceStatus.notEvaluated,
                                                                        overview: complianceStatus.overview,
                                                                        //Carteira sem nada a corrigir abre direto no
                                                                        //que ela tem a mostrar; havendo desenquadramento
                                                                        //ou pendência, abre onde eles estão
                                                                        initialTab: complianceStatus.isOut
                                                                            || complianceStatus.notEvaluatedBalance > 0 ? 0 : 1,
                                                                    },
                                                                }))} />
                                                    </span>
                                                </Tooltip> : null
                                        }

                                        <UnoButton
                                            size={'small'}
                                            onClick={() => setFlagDoExcelPortfolio(true)}
                                            type='success'
                                            startIcon={<PrintIcon />}>
                                            {"Excel"}
                                        </UnoButton>

                                    </div> : null
                            }



                            {
                                //Exibido apenas no menu de APRS
                                tabValue == 2 ?
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                        <UnoButton
                                            style={{ marginRight: '16px' }}
                                            size={'small'}
                                            onClick={() => setFlagDoExcelTransactions(true)}
                                            type='success'
                                            startIcon={<PrintIcon />}>
                                            {"Excel"}
                                        </UnoButton>

                                        <UnoButton
                                            size={'small'}
                                            onClick={() => setFlagDoReportBatchAprs(true)}
                                            type='primary'
                                            startIcon={<PrintIcon />}>
                                            {"Gerar lote"}
                                        </UnoButton>
                                    </div> : null
                            }

                            <MyToggleSegregationButton
                                value={formats}
                                handleValue={handleFormat}
                                disabled={innerLoad.show && !innerLoad.emptyMessage}
                                clientOn={clientOn}
                            />

                            {
                                //Exibido apenas no menu de CONTAS
                                tabValue == ACCOUNT_TAB_INDEX && !currentUser?.user?.isViewer ?
                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '16px' }}>
                                        <UnoButton
                                            size={'small'}
                                            onClick={() => setFlagDoNewAccount(true)}
                                            type='primary'
                                            startIcon={<AddIcon />}>
                                            {"Nova conta"}
                                        </UnoButton>

                                    </div> : null
                            }
                        </>
                    )}

                    {tabValue == 3 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0, whiteSpace: 'nowrap' }}>
                            <ToggleButtonGroup
                                className={classes.toogleButton}
                                exclusive
                                value={costsPeriodType}
                                onChange={handleCostsPeriodType}
                                aria-label="Tipo de período">
                                <ToggleButton value="mensal">{'Mensal'}</ToggleButton>
                                <ToggleButton value="trimestral">{'Trimestral'}</ToggleButton>
                                <ToggleButton value="semestral">{'Semestral'}</ToggleButton>
                                <ToggleButton value="anual">{'Anual'}</ToggleButton>
                            </ToggleButtonGroup>

                            <MySelect
                                value={costsYear}
                                onChange={(e) => handleCostsYear(e.target.value)}
                                customWidth="80px"
                                options={costsYearOptions.map((y, index) => (
                                    <option key={'costs-year-' + index} value={index}>{y}</option>
                                ))}
                            />

                            {costsPeriodType === 'mensal' && (
                                costsMonthOptions.length > 0 ?
                                    <MySelect
                                        value={costsSubPeriod}
                                        onChange={(e) => setCostsSubPeriod(parseInt(e.target.value))}
                                        customWidth="140px"
                                        options={costsMonthOptions.map((opt, index) => (
                                            <option key={'costs-month-' + index} value={index}>{opt.name}</option>
                                        ))}
                                    />
                                    : <span style={{ fontSize: '0.8em', color: '#999' }}>{'Não há mês disponível'}</span>
                            )}

                            {costsPeriodType === 'trimestral' && (
                                costsQuarterOptions.length > 0 ?
                                    <MySelect
                                        value={costsSubPeriod}
                                        onChange={(e) => setCostsSubPeriod(parseInt(e.target.value))}
                                        customWidth="220px"
                                        options={costsQuarterOptions.map((opt, index) => (
                                            <option key={'costs-quarter-' + index} value={index}>{opt.name}</option>
                                        ))}
                                    />
                                    : <span style={{ fontSize: '0.8em', color: '#999' }}>{'Não há trimestre completo'}</span>
                            )}

                            {costsPeriodType === 'semestral' && (
                                costsSemesterOptions.length > 0 ?
                                    <MySelect
                                        value={costsSubPeriod}
                                        onChange={(e) => setCostsSubPeriod(parseInt(e.target.value))}
                                        customWidth="220px"
                                        options={costsSemesterOptions.map((opt, index) => (
                                            <option key={'costs-semester-' + index} value={index}>{opt.name}</option>
                                        ))}
                                    />
                                    : <span style={{ fontSize: '0.8em', color: '#999' }}>{'Não há semestre completo'}</span>
                            )}

                            <UnoButton
                                isIconButton
                                size='small'
                                type='primary'
                                myIcon={<PrintIcon />}
                                disabled={!costsReportData}
                                onClick={() => costsReportData && dispatch(allActions.reportLoadActions.setReportLoad({
                                    show: true,
                                    reportType: 'costs',
                                    message: 'Gerando relatório de custos...',
                                    startDate: costsReportData.startDate,
                                    endDate: costsReportData.endDate,
                                    reportData: {
                                        funds: costsReportData.funds,
                                        institutions: costsReportData.institutions,
                                        otherCosts: costsReportData.otherCosts,
                                    },
                                }))}
                            />
                        </div>
                    )}
                </div>


            </div>

            <Switch className={classes.switch}>
                <Route path="/portfolio/assets">
                    <AssetsScreen accountRegimeId={formats}
                        flagDoExcelPortfolio={flagDoExcelPortfolio}
                        onComplianceLoaded={setComplianceStatus}
                        resetFlag={resetFlag} />
                </Route>
                <Route path="/portfolio/accounts">
                    <AccountsScreen
                        flagDoNewAccount={flagDoNewAccount}
                        resetFlag={resetFlag}
                        accountRegimeId={formats} />
                </Route>
                <Route path="/portfolio/aprs">
                    <AprsScreen accountRegimeId={formats}
                        flagDoReportBatchAprs={flagDoReportBatchAprs}
                        flagDoExcelTransactions={flagDoExcelTransactions}
                        flagDoReorganizeAprs={flagDoReorganizeAprs}
                        resetFlag={resetFlag} />
                </Route>
                <Route path="/portfolio/costs">
                    <CostsScreen
                        selectedYear={costsYearValue}
                        periodType={costsPeriodType}
                        subPeriod={costsSubPeriodValue}
                        onDataLoaded={setCostsReportData}
                    />
                </Route>
            </Switch>

            <PortfolioAnalysisModal
                analysis={portfolioAnalysis}
                period={{
                    month: clientOn?.client?.selectedPortfolioMonth,
                    year: clientOn?.client?.selectedPortfolioYear,
                }}
                open={showPortfolioAnalysisModal}
                closeModal={() => setShowPortfolioAnalysisModal(false)} />
        </div>
    );
}


